import { IManagableObject } from "../../IManagableObject";
/*
type — тип зоны (point, polygon, polyline)
fillColor — Цвет заливки (#RRGGBB)
fillOpacity — Прозрачность заливки 0.. 1
strokeDashstyle - стиль линии обрамления (solid, dot, dash, dashdot)
strokeWidth — ширина линии обрамления в пикселях
strokeOpacity — прозрачность линии обрамления 0..1
 */

export class GeozoneStyleViewModel {
  type: string = "point";
  fillColor: string = "#FF0000";
  fillOpacity: number = 1;
  strokeDashstyle: string = "solid";
  strokeColor: string = "#00FF00";
  strokeWidth: number = 3;
  strokeOpacity: number = 1;

  init(data?: any) {
    if (data) {
      this.type = data["type"].toLowerCase();
      this.fillColor = data["fillColor"];
      this.strokeColor = data["strokeColor"];
      this.fillOpacity = data["fillOpacity"];
      this.strokeDashstyle = data["strokeDashstyle"];
      this.strokeWidth = data["strokeWidth"];
      this.strokeOpacity = data["strokeOpacity"];
    }
  }

  static fromJS(data: any): GeozoneStyleViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new GeozoneStyleViewModel();
    result.init(data);
    return result;
  }
  public Clone(): GeozoneStyleViewModel {
    let result = new GeozoneStyleViewModel();
    result.type = this.type;
    result.fillColor = this.fillColor;
    result.strokeColor = this.strokeColor;
    result.fillOpacity = this.fillOpacity;
    result.strokeDashstyle = this.strokeDashstyle;
    result.strokeWidth = this.strokeWidth;
    result.strokeOpacity = this.strokeOpacity;
    return result;
  }
  public IsEqual(obj: GeozoneStyleViewModel): boolean {
    return obj.type == this.type &&
      obj.fillColor == this.fillColor &&
      obj.strokeColor == this.strokeColor &&
      obj.fillOpacity == this.fillOpacity &&
      obj.strokeDashstyle == this.strokeDashstyle &&
      obj.strokeWidth == this.strokeWidth &&
      obj.strokeOpacity == this.strokeOpacity;
  }
}

export class GeozoneViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  Comment: string = "";
  Points: string = "";
  Area: number = 0;
  Flags: string = "";
  Radius: number = 100;
  MaxSpeed: number = 0;
  IconId?: number;
  // TODO: remove groups, keep only GroupIds
  Groups: number[] = [];
  GroupIds: number[] = [];
  ContainerId?: number;
  //OwnerName: string = "";
  Priority: number = 10;
  Style: GeozoneStyleViewModel = new GeozoneStyleViewModel();
  Objects: number[] = [];

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Comment = data["comment"];
      this.Points = data["points"];
      this.Style = GeozoneStyleViewModel.fromJS(data["style"]);
      this.Flags = data["flags"];
      this.Radius = data["radius"];
      this.MaxSpeed = data["maxSpeed"];
      this.IconId = data["iconId"];
      this.Groups = data["groupIds"];
      this.GroupIds = data["groupIds"];
      this.ContainerId = data["containerId"];
      this.Priority = data["priority"];
      this.Area = data["area"];
    }
  }

  static fromJS(data: any): GeozoneViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new GeozoneViewModel();
    result.init(data);
    return result;
  }

  public Clone(): GeozoneViewModel {
    let result = new GeozoneViewModel();
    result.Id = this.Id;
    result.Name = this.Name;
    result.Comment = this.Comment;
    result.Points = this.Points;
    result.Style = this.Style.Clone();
    result.Flags = this.Flags;
    result.Radius = this.Radius;
    result.MaxSpeed = this.MaxSpeed;
    result.IconId = this.IconId;
    result.Groups = [...this.Groups];
    result.GroupIds = [...this.GroupIds];
    result.ContainerId = this.ContainerId;
    result.Objects = [...this.Objects];
    return result;
  }
  public IsEqual(obj: GeozoneViewModel): boolean {
    return obj &&
      obj.Id == this.Id &&
      obj.Name == this.Name &&
      obj.Comment == this.Comment &&
      obj.Points == this.Points &&
      obj.Style.IsEqual(this.Style) &&
      obj.Flags == this.Flags &&
      obj.Radius == this.Radius &&
      obj.MaxSpeed == this.MaxSpeed &&
      obj.IconId == this.IconId &&
      JSON.stringify(obj.Groups ?? []) == JSON.stringify(this.Groups ?? []) &&
      obj.ContainerId == this.ContainerId &&
      JSON.stringify(obj.Objects ?? []) == JSON.stringify(this.Objects ?? []);
  }


  IsChecked: boolean;
}
